export enum AdminCosmeticStatus {
  Draft = 'DRAFT',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}
